import React from 'react'
import injectStyles from 'react-jss'
import moment from 'moment-timezone'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import styles from './styles.js'
import ActionsBlock from './ActionsBlock'
import commentSvg from './Assets/comment.svg'

import classNames from 'classnames'
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator'

const UserRequestsTable = ({
  data,
  headers,
  classes,
  openViewModal,
  openRejectModal,
  openApproveModal,
  openAddCommentModal,
  openAddInternalCommentModal,
  isLoading,
  timezone,
}) => {
  const renderTableCell = ({ row, key, type, openViewModal }) => {
    switch (type) {
      case 'comment':
        return (
          <div>
            <Typography
              className={classNames({
                [classes.text]: true,
                [classes.comment]: true,
                [classes.commentWrapper]: true,
              })}
            >
              {row[key] || '-'}
              <img
                className={classes.commentIcon}
                onClick={() => openAddCommentModal(row)}
                src={commentSvg}
                alt={'comment'}
              />
            </Typography>
          </div>
        )
      case 'internalComment':
        return (
          <div>
            <Typography
              className={classNames({
                [classes.text]: true,
                [classes.comment]: true,
                [classes.commentWrapper]: true,
              })}
            >
              {row[key] || '-'}
              <img
                className={classes.commentIcon}
                onClick={() => openAddInternalCommentModal(row)}
                src={commentSvg}
                alt={'comment'}
              />
            </Typography>
          </div>
        )

      case 'string':
        return row && row[key] ? (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.minWidth]: true,
            })}
          >
            {row[key] || '-'}
          </Typography>
        ) : (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.minWidth]: true,
            })}
          >
            {'-'}
          </Typography>
        )

      case 'review':
        return (
          <div
            className={classNames(classes.nmbrsModalButton, classes.comment)}
            onClick={() => openViewModal(row)}
          >
            View
          </div>
        )
      case 'date':
        return (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.minWidth]: true,
            })}
          >
            {row && row[key]
              ? moment
                  .tz(new Date(Number(row[key])), timezone)
                  .format('YYYY-MM-DD HH:mm')
              : '-'}
          </Typography>
        )
      case 'actions':
        return row && row[key] !== null && row[key] !== undefined ? (
          <ActionsBlock
            item={row}
            onApprove={openApproveModal}
            onReject={openRejectModal}
          />
        ) : (
          <Typography className={classes.text}>{'-'}</Typography>
        )

      default:
        return null
    }
  }

  return (
    <Box className={classes.wrapper}>
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <Box className={classes.table}>
          <TableContainer className={classes.tableContainer}>
            <Table stickyHeader size="small">
              <TableHead className={classes.tableHead}>
                <TableRow className={classes.tableRow}>
                  {headers.map((headCell, index) => (
                    <TableCell
                      key={headCell.key}
                      align={index === headers.length - 1 ? 'center' : 'left'}
                      className={classNames({
                        [classes.tableHeaderCell]: index !== 0,
                        [classes.firstTableHeaderCell]: index === 0,
                        [classes.commentWrapper]: [
                          'comment',
                          'internalComment',
                        ].includes(headCell.key),
                      })}
                    >
                      <Typography className={classes.tableHeadersLabel}>
                        {headCell.label}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data &&
                  data.map(row => {
                    return (
                      <TableRow
                        hover={false}
                        tabIndex={-1}
                        key={row.id}
                        className={classes.tableRow}
                      >
                        {headers.map(({ key, type }, index) => (
                          <TableCell
                            key={`${key}-${index}`}
                            align={
                              index === headers.length - 1 ? 'center' : 'left'
                            }
                          >
                            {renderTableCell({
                              row,
                              key,
                              type,
                              openViewModal,
                            })}
                          </TableCell>
                        ))}
                      </TableRow>
                    )
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Box>
  )
}

export default injectStyles(styles)(UserRequestsTable)
